module.exports = __webpack_public_path__ + "img/goods_coupon_used.fb6bcf73.png";